module.exports = __webpack_public_path__ + "assets/phone-icon.aaeb7a06.svg";